/**
 * @fileoverview "Completed" tag shown for finished projects (AR-684).
 */

import { Badge } from '@mantine/core'
import { useTranslation } from 'react-i18next'

export function CompletedBadge() {
  const { t } = useTranslation()

  return (
    <Badge color="green" variant="light" radius="sm" sx={{ flexShrink: 0 }}>
      {t('task_tracker.status.completed')}
    </Badge>
  )
}
